import { useTranslation } from 'react-i18next'

import { useToastStore } from '../../store/toastStore'

/**
 * The toast of design page 16: pinned just above the floating bottom bar (V8:
 * the capsule's top is 84px plus the home indicator), on the ink colour, with
 * a gold «باشه». Mounted once in `App`, outside the routes,
 * so it survives the navigation that usually follows the action it confirms.
 */
export default function ToastBar() {
  const { t } = useTranslation('common')
  const toast = useToastStore((s) => s.toast)
  const dismiss = useToastStore((s) => s.dismiss)
  if (!toast) return null
  return (
    <div className="pointer-events-none fixed inset-x-0 bottom-[calc(96px+env(safe-area-inset-bottom))] z-[55] flex justify-center px-3.5">
      <div
        role="status"
        className="pointer-events-auto flex w-full max-w-md items-center gap-[11px] rounded-[14px] bg-ink px-[15px] py-[13px] shadow-[0_10px_26px_rgba(0,0,0,0.28)]"
      >
        <span className="flex-1 text-[12.5px] leading-[1.8] text-on-ink">{toast}</span>
        <button type="button" onClick={dismiss} className="shrink-0 text-xs font-bold text-accent">
          {t('ok')}
        </button>
      </div>
    </div>
  )
}
